<template>
  <div class="">
    <button 
      class="w-full appearance-none text-left flex justify-between items-center border-b border-gray-800 pb-3 my-4" 
      @click="togglePanel" 
      :aria-expanded="open" 
      :aria-controls="htmlId"
    >
      <slot name="header" :open="open"></slot>
      <svg-icon :name="iconName" classes="w-4 h-4 mx-3 flex-shrink-0 text-gray-800"></svg-icon>
    </button>

    <transition-expand>
      <div :id="htmlId" :aria-hidden="!open" v-show="open" class="mb-8">
        <slot name="content"></slot>
      </div>
    </transition-expand>
  </div>
</template>

<script>
/** 
 * Accordion panel can be used without accordion group if you don't need the auto-collapsing feature
 */

import UuidGenerator from '@/lib/uuid.js'

export default {
  mixins: [UuidGenerator],

  props: {
    expanded: {
      default: false
    }
  },

  data() {
    return {
      open: this.expanded,
    }
  },

  computed: {
    htmlId() {
      return `collapsible-${this.uuid}`;
    },
    iconName() {
      return this.open ? 'caret-up' : 'caret-down';
    }
  },

  methods: {
    togglePanel() {
      this.open = !this.open;

      this.$parent.$emit("accordion-panel-toggled", { 
        htmlId: this.htmlId,
        open: this.open 
      });
    },

    closePanel() {
      this.open = false;
    },

    openPanel() {
      this.open = true;
    }
  }
}
</script>
